/**
 * RuleId — Compile-time safe union of all valid rule identifiers.
 *
 * Generated from the per-category rule files. Any typo in a getRuleValue()
 * call will now produce a TS compile error instead of a runtime exception.
 */

import { ELECTRICAL_RULES } from './rules/electrical';
import { HEATER_RULES } from './rules/heater';
import { FOUNDATION_RULES } from './rules/foundation';
import { FRAMING_RULES } from './rules/framing';
import { WEIGHT_RULES } from './rules/weight';
import { DIMENSIONS_RULES } from './rules/dimensions';
import { VENTILATION_RULES } from './rules/ventilation';
import { GLASS_RULES } from './rules/glass';
import { PERMIT_RULES } from './rules/permit';
import { BBR_RULES } from './rules/bbr';
import { ERGONOMICS_RULES } from './rules/ergonomics';
import { EXTERIOR_RULES } from './rules/exterior';
import { SNOWZONE_RULES } from './rules/snowzone';
import { PRICES_RULES } from './rules/prices';

/**
 * Combined tuple of all rules from every category.
 * The `as const satisfies` on each category file preserves literal types.
 */
export const ALL_RULES = [
    ...ELECTRICAL_RULES,
    ...HEATER_RULES,
    ...FOUNDATION_RULES,
    ...FRAMING_RULES,
    ...WEIGHT_RULES,
    ...DIMENSIONS_RULES,
    ...VENTILATION_RULES,
    ...GLASS_RULES,
    ...PERMIT_RULES,
    ...BBR_RULES,
    ...ERGONOMICS_RULES,
    ...EXTERIOR_RULES,
    ...SNOWZONE_RULES,
    ...PRICES_RULES,
] as const;

/** Union of every valid rule ID string. */
export type RuleId = typeof ALL_RULES[number]['id'];
